import { Button } from 'antd';
import AppleSignin from 'react-apple-signin-auth';
import type { AppleAuthResponse } from 'react-apple-signin-auth';

import { images } from '@/shared/assets/images/images';

import s from '@/shared/ui/AuthForm.module.css';

interface SocialButtonsProps {
  onGoogle: () => void;
  onFacebook: () => void;
  onApple: (response: AppleAuthResponse) => void;
  // Where Apple sends the user back to
  redirectPath: string;
}

// Google, Facebook and Apple sign-in buttons in one row
export const SocialButtons = ({
  onGoogle,
  onFacebook,
  onApple,
  redirectPath,
}: SocialButtonsProps) => (
  <div className={s.socialButtons}>
    <Button
      icon={<img className={s.socialIcon} src={images.google} alt="" />}
      onClick={onGoogle}
    >
      Google
    </Button>
    <Button
      icon={<img className={s.socialIcon} src={images.facebook} alt="" />}
      onClick={onFacebook}
    >
      Facebook
    </Button>
    <AppleSignin
      authOptions={{
        clientId: import.meta.env.VITE_APPLE_CLIENT_ID,
        scope: 'email name',
        redirectURI: import.meta.env.VITE_BASE_URI + redirectPath,
        state: 'state',
        nonce: 'nonce',
        usePopup: true,
      }}
      noDefaultStyle={false}
      onSuccess={onApple}
      onError={onApple}
      skipScript={false}
      render={(renderProps) => (
        <Button
          icon={<img className={s.socialIcon} src={images.apple} alt="" />}
          onClick={renderProps.onClick}
        >
          Apple
        </Button>
      )}
    />
  </div>
);
